import Link from "next/link"
import ProfileDropdown from "./ProfileDropdown"
import ProjectsNavBadge from "./ProjectsNavBadge"
import PushNotificationToggle from "./PushNotificationToggle"
import AddToHomeScreen from "./AddToHomeScreen"

interface HeaderProps {
  userId: string
  userName: string
  notifications: {
    unreadMessageCount: number
    pendingConnectionCount: number
  }
}

export default function Header({ userId, userName, notifications }: HeaderProps) {
  return (
    <header
      className="sticky top-0 z-10"
      style={{ background: "#0F172A", borderBottom: "1px solid #1e293b" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo + desktop nav */}
          <div className="flex items-center space-x-8">
            <Link
              href="/feed"
              className="text-xl font-bold tracking-tight flex-shrink-0"
              style={{ color: "#f1f5f9" }}
            >
              BLUE COLLAR<span style={{ color: "#38BDF8" }}> SOCIAL</span>
            </Link>

            <nav className="hidden md:flex space-x-1">
              {[
                { href: "/feed",                    label: "Feed" },
                { href: "/jobs",                    label: "Jobs" },
                { href: "/directory",               label: "Directory" },
                { href: "/federal/opportunities",   label: "Federal Bids" },
              ].map(({ href, label }) => (
                <Link
                  key={href}
                  href={href}
                  className="app-nav-link px-3 py-2 text-sm font-medium rounded-md transition-colors"
                  style={{ color: "#94a3b8" }}
                >
                  {label}
                </Link>
              ))}

              <ProjectsNavBadge />

              <Link
                href="/messages"
                className="app-nav-link px-3 py-2 text-sm font-medium rounded-md transition-colors relative"
                style={{ color: "#94a3b8" }}
              >
                Messages
                {notifications.unreadMessageCount > 0 && (
                  <span className="absolute top-1.5 -right-0.5 bg-red-500 rounded-full h-2 w-2" />
                )}
              </Link>
            </nav>
          </div>

          {/* Right-side actions */}
          <div className="flex items-center gap-3">
            <PushNotificationToggle />
            <AddToHomeScreen />
            <ProfileDropdown userId={userId} userName={userName} />
          </div>

        </div>
      </div>
    </header>
  )
}
